
import React from 'react';
import { TableCell, TableRow } from '@mui/material';
import { Image, Space } from "antd";
import customStyles from "../../../../../assets/styles/customStyles";
import { hsnHead } from "../../../../../config/constant";
import CustomInfiniteScroll from "../../../../Shared/components/CustomInfiniteScroll";
import { NavLink } from "react-router-dom";
import EditIcon from "../../../../../assets/images/icon_actions/Edit.svg";
import DeleteIcon from "../../../../../assets/images/icon_actions/Delete Icon.svg";
import { checkCRUDPermission, getColumnWidth } from "../../../../../helpers/utilities";
import clsx from "clsx";

export const HsnCodeTable = (props) => {
    const { onRequestSort, sortOrder, sortBy, details, loadMore, onEdit, onDelete, loadMoreTask, loadMoreContent, roleManagement, moduleType } = props;

    const classes = customStyles();
    return (
        <CustomInfiniteScroll
            loadMore={loadMore}
            loadMoreContent={loadMoreContent}
            heads={hsnHead}
            onRequestSort={(sortBy, sortOrder) => onRequestSort(sortBy, sortOrder)}
            sortOrder={sortOrder}
            sortBy={sortBy}
            loadMoreTask={() => loadMoreTask()}
            component={
                <>
                    {
                        !loadMore || details === '' ? (
                            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell className={classes.textAlignCenter} colSpan={6}><div className={classes.loadMoreCircle}></div></TableCell>
                            </TableRow>
                        ) : (
                            <React.Fragment>
                                {
                                    details && Array.isArray(details) && details?.length > 0 ? details?.map((data, i) => (
                                        <TableRow
                                            key={i}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell style={{ width: getColumnWidth(hsnHead, 0) }}><span style={{ width: getColumnWidth(hsnHead, 0) }}>{data.hsnCode}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(hsnHead, 1) }}><span style={{ width: "100%", whiteSpace: "break-spaces", lineHeight: 1.5 }}>{data.description ? data.description : '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(hsnHead, 2) }}><span style={{ width: getColumnWidth(hsnHead, 2) }}>{data.chapter ? data.chapter : '---'}</span></TableCell>
                                            <TableCell style={{ width: getColumnWidth(hsnHead, 3) }}><span style={{ width: getColumnWidth(hsnHead, 3) }}>{data.productGst ? data.productGst : '---'}</span></TableCell>
                                            <TableCell>
                                                {
                                                    moduleType !== 'Admin' ? <Space direction="horizontal" align="center" size={[0, 0]} className={classes.iconPadding}>
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('HSN Code', 'edit', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onEdit(data)}>
                                                                <Image src={EditIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                        {
                                                            roleManagement !== '' && checkCRUDPermission('HSN Code', 'deletable', 'Younote Admin') &&
                                                            <NavLink to={"#"} onClick={() => onDelete(data)} >
                                                                <Image src={DeleteIcon} preview={false} />
                                                            </NavLink>
                                                        }
                                                    </Space> : '---'
                                                }
                                            </TableCell>
                                        </TableRow>
                                    )) : (
                                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                            <TableCell className={classes.textAlignCenter} colSpan={6}>
                                                <p className={clsx(classes.noResultsText, classes.textAlignCenter)}> {'Start Creating HSN Code'}</p>
                                            </TableCell>
                                        </TableRow>
                                    )
                                }
                            </React.Fragment>
                        )
                    }
                </>
            }
        />
    )
}